module.exports = __webpack_public_path__ + "static/steps-path-3-e3afbe4b331c7d64b16216a88add6bcd.jpg";